import React, { useContext, useEffect, useState, createContext } from 'react';
import Spin from 'antd/lib/spin';
import { LoadingOutlined } from '@ant-design/icons';
import {
  getPaymentPlans,
  getAccountTypes,
  getBankAccountTypes,
} from '../../../api/buyAPI';
import { DeclaredComponent } from '../../DynamicComponent';
import { ModelContext } from '../../metadata/ModelSource';
import { PremiumAlertMessageContext } from '../../../context/PremiumAlertMessageProvider';
import { getApplication } from '../../../api/applicationAPI';
import { navigateToHome } from '../../../navigation/navigationHistory';

const initialContext = {
  paymentPlans: [],
  accountTypes: [],
  bankAccountTypes: [],
  downPaymentAmt: '',
  setDownPaymentAmt: () => {},
};

export const PaymentDetailsContext = createContext(initialContext);

export const PaymentDetailsForm = ({ content }) => {
  const [paymentPlans, setPaymentPlans] = useState([]);
  const [accountTypes, setAccountTypes] = useState();
  const [bankAccountTypes, setBankAccountTypes] = useState();
  const [downPaymentAmt, setDownPaymentAmt] = useState();
  const applicationModel = useContext(ModelContext);
  const {data: model} = applicationModel;
  const { setPaymentTotalPremiumAmt } = useContext(PremiumAlertMessageContext);

  useEffect(()=>{
    const total =
      parseFloat(model.basicPolicy.writtenPremiumAmt) +
      parseFloat(model.basicPolicy.writtenFeeAmt);
    setPaymentTotalPremiumAmt(total)
  },[])

  useEffect(() => {
    const getPlans = async () => {
      return await getPaymentPlans(applicationModel.data.systemId).then(
        (res) => {
          setPaymentPlans(res.data.applicationPayPlanListItems);
        }
      ).catch(err => {
        const status = (err.response ? err.response.status : 500);
        if (status == 403) navigateToHome( );  // Permission denied suggests application-session ended
        throw (err);
      });
    };

    const getTypes = async () => {
      return await getAccountTypes().then((res) => {
        setAccountTypes(res.data.options);
      });
    };

    const getBankTypes = async () => {
      return await getBankAccountTypes().then((res) => {
        setBankAccountTypes(res.data.options);
      });
    };

    getPlans();
    getTypes();
    getBankTypes();
    getApplication(applicationModel.data.systemId);
  }, []);

  const antIcon = <LoadingOutlined style={{ fontSize: '38px' }} spin />;
  const app = applicationModel.data;

  if (app.policyRef && app.basicPolicy.policyNumber) navigateToHome( );  // Already paid
  if (!paymentPlans || !Array.isArray(paymentPlans) || paymentPlans.length <= 0)
    return (
      <div style={{ height: '300px', width: '100%' }}>
        <Spin
          indicator={antIcon}
          style={{ top: '50%', left: '50%', position: 'absolute' }}
        />
      </div>
    );

  return (
    <PaymentDetailsContext.Provider
      value={{
        ...initialContext,
        paymentPlans,
        accountTypes,
        bankAccountTypes,
        downPaymentAmt,
        setDownPaymentAmt,
      }}
    >
      {content &&
      content.map((component, index) => {
        return <DeclaredComponent declaration={component}  key={index} />;
      })}
    </PaymentDetailsContext.Provider>
  );
};
